module.exports = __webpack_public_path__ + "static/img/circle.22469a2d.gif";